"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _entityLite = require("./entity-lite");
var _image = _interopRequireDefault(require("./image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createPersonLite = function createPersonLite(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var _createEntityLite = (0, _entityLite.createEntityLite)({
      sys: sys,
      fields: fields
    }),
    id = _createEntityLite.id,
    url = _createEntityLite.url;
  return {
    id: id,
    url: fields !== null && fields !== void 0 && fields.external ? (0, _utils.getProp)(fields, 'externalLink') : url,
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields.image) : null,
    jobTitle: (0, _utils.getProp)(fields, 'jobTitle'),
    yearsExperience: (0, _utils.getProp)(fields, 'yearsExperience'),
    shortBio: (0, _utils.getProp)(fields, 'shortBio'),
    external: (0, _utils.getProp)(fields, 'external')
  };
};
var _default = createPersonLite;
exports["default"] = _default;